import { mergeAttributes, Node } from '@tiptap/core';
import { ReactNodeViewRenderer } from '@tiptap/react';

import { Footnote } from '../../components/footnote';

const hashUrl = (str: string) => {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = (hash << 5) - hash + str.charCodeAt(i);
    hash |= 0; // Convert to 32bit integer
  }
  return (hash >>> 0).toString(36).padStart(7, '0');
};

export const createFootnoteNode = (cellId: string) =>
  Node.create({
    name: 'footnoteNode',
    group: 'inline',
    inline: true,
    atom: true,
    selectable: false,
    draggable: true,

    addStorage() {
      return {
        numberMap: new Map<string, number>(),
      };
    },

    parseHTML() {
      return [{ tag: 'footnote-node' }];
    },
    renderText({ node }) {
      return `[${this.storage.numberMap.get(node.attrs.href) ?? node.attrs.href}]`;
    },
    renderHTML({ HTMLAttributes }) {
      return ['footnote-node', mergeAttributes(HTMLAttributes)];
    },
    addNodeView() {
      return ReactNodeViewRenderer(Footnote);
    },

    addAttributes() {
      return {
        metadata: {
          default: undefined,
        },
        href: {
          default: undefined,
        },
        label: {
          default: undefined,
        },
        citeId: {
          default: undefined,
          parseHTML: (element) => hashUrl((element.getAttribute('href') ?? '') + cellId),
        },
        pages: {
          default: undefined,
        },
        num: {
          default: undefined,
          parseHTML: (element) => {
            const numberMap: Map<string, number> = this.storage.numberMap;
            const href = element.getAttribute('href') ?? '';
            if (!numberMap.has(href)) {
              numberMap.set(href, numberMap.size + 1);
            }
            return numberMap.get(href) ?? 1;
          },
        },
      };
    },
  });
